module.exports = __webpack_public_path__ + "static/media/earth-rhythm-500_f876b35c-f4b7-46e4-9334-5bc9eba4fb73.fbc785b4.png";